import React, {Fragment, useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {cmsService} from "../../utils/axios";

import logoIcon from '../../assets/images/icons/logo.svg';
import fbIcon from '../../assets/images/icons/social/fb.svg';
import twIcon from '../../assets/images/icons/social/tw.svg';
import SellerCodeReader from "../../utils/SellerCodeReader";
import {SellerContext} from "../../context/seller-context";
import analyitics from "../../utils/analytics";

const ZALETY_FALLBACK = [
    "Gwarancja zwrotu",
    "Brak limitu kilometrów",
    "Karta serwisowa",
    "Monitoring GPS",
    "Rejestracja auta",
];

function Footer(props) {
    const [footerData, setFooterData] = useState({
        "Footer1Header": null,
        "Footer1Column": null,
        "Footer2Header": null,
        "Footer2Column": null,
        "Footer3Header": null,
        "Footer3Column": null,
        "FooterBottomText": null,
        "FacebookURL": "https://www.facebook.com/ekspercileasingu/",
        "YoutubeURL": "https://www.youtube.com/channel/UCqQprAhU9WR_WrKJJl16-Ow",
        "LinkedInURL": "https://pl.linkedin.com/company/go-leasing"
    });

    const sellerCodeReader = new SellerCodeReader();
    const seller = useContext(SellerContext);

    const phoneClickHandler = () => {
        analyitics.sendEvent({
            category: 'Telefon',
            action: 'Klikniecie',
            label: 'Kliknieto w nr telefonu',
            value: 1
        });
    };

    useEffect(() => {
        cmsService.get('/FooterConfig/1/')
            .then(response => setFooterData(response.data))
            .catch(() => {});
    }, []);

    return (
        <Fragment>
            <footer className="site-footer">
                <div className="container">
                    <div className="site-footer-grid">

                        {/* Column 1: Contact */}
                        <div className="site-footer-col site-footer-col--contact">
                            <Link to="/" className="site-footer-logo">
                                <img src={logoIcon} alt="GO-auto"/>
                            </Link>
                            <div className="site-footer-contact-items">
                                <a
                                    href={"tel:" + props.seller.phone}
                                    className="site-footer-contact-item"
                                    onClick={phoneClickHandler}
                                >
                                    <span className="site-footer-contact-icon">
                                        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.3 13.98c-.02 0-1.97-.41-2.43-.51a1.36 1.36 0 0 0-1.32.37l-1.14 1.14a10.47 10.47 0 0 1-4.38-4.38l1.14-1.14c.36-.35.5-.85.37-1.32C10.44 7.68 10.02 5.73 10 5.7A1.37 1.37 0 0 0 8.63 4.6H5.7A1.37 1.37 0 0 0 4.33 6c.15 8.04 7.63 14.52 14 14.67A1.37 1.37 0 0 0 19.73 19.3v-2.95c0-.69-.51-1.28-1.43-1.37z" fill="#1a1a1a"/>
                                        </svg>
                                    </span>
                                    {props.seller.phone}
                                </a>
                                <a href={"mailto:" + props.seller.email} className="site-footer-contact-item">
                                    <span className="site-footer-contact-icon">
                                        <svg width="16" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V2l8 5 8-5v2z" fill="#1a1a1a"/>
                                        </svg>
                                    </span>
                                    {props.seller.email}
                                </a>
                            </div>
                            <address className="site-footer-address">
                                {props.seller.name && <span>{props.seller.name}<br/></span>}
                                {props.seller.street && <span>{props.seller.street}<br/></span>}
                                {(props.seller.postalCode || props.seller.city) && (
                                    <span>{props.seller.postalCode} {props.seller.city}<br/></span>
                                )}
                                <span className="site-footer-hours">Pon - Pt 08:00 - 20:00</span>
                            </address>
                            <div className="site-footer-social">
                                <a href={footerData.FacebookURL} target="_blank" rel="noopener noreferrer" className="site-footer-social-link">
                                    <img src={fbIcon} alt="Facebook"/>
                                </a>
                                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="site-footer-social-link site-footer-social-link--tw">
                                    <img src={twIcon} alt="Twitter"/>
                                </a>
                            </div>
                        </div>

                        {/* Column 2: Nasze Zalety */}
                        <div className="site-footer-col">
                            <h4 className="site-footer-col-heading">
                                {footerData.Footer1Header || "Nasze Zalety"}
                            </h4>
                            {footerData.Footer1Column
                                ? <div className="site-footer-links" dangerouslySetInnerHTML={{__html: footerData.Footer1Column}}/>
                                : (
                                    <ul className="site-footer-links">
                                        {ZALETY_FALLBACK.map(item => (
                                            <li key={item}>{item}</li>
                                        ))}
                                    </ul>
                                )
                            }
                        </div>

                        {/* Column 3: Nasze Marki */}
                        <div className="site-footer-col">
                            <h4 className="site-footer-col-heading">Nasze Marki</h4>
                            <ul className="site-footer-links">
                                <li><a href={seller.webpageUrl}>GO-leasing</a></li>
                                <li><a href={"https://go-auto.pl/" + sellerCodeReader.readSellerCodeForLeasingOnline()}>GO-auto</a></li>
                                <li><a href="https://go-auto.pl/ubezpieczenie-gap">GO-gap</a></li>
                                <li><a href="https://go-bot.pl">GO-bot</a></li>
                                <li><a href={"https://lo.go-leasing.pl/" + sellerCodeReader.readSellerCodeForLeasingOnline()}>LeasinGOnline</a></li>
                            </ul>
                        </div>

                        {/* Column 4: Nasz Serwis */}
                        <div className="site-footer-col">
                            <h4 className="site-footer-col-heading">
                                {footerData.Footer3Header || "Nasz Serwis"}
                            </h4>
                            {footerData.Footer3Column
                                ? <div className="site-footer-links" dangerouslySetInnerHTML={{__html: footerData.Footer3Column}}/>
                                : (
                                    <ul className="site-footer-links">
                                        <li><Link to="/faq">FAQ</Link></li>
                                        <li><Link to="/kontakt">Kontakt</Link></li>
                                        <li><a href="https://go-leasing.pl/nowosci/">Blog</a></li>
                                    </ul>
                                )
                            }
                        </div>

                    </div>
                </div>

                <div className="site-footer-bottom">
                    <div className="container">
                        <div className="site-footer-bottom-inner">
                            <div className="site-footer-policies">
                                <Link to="/polityka-prywatnosci" className="site-footer-policy-link">Polityka prywatności</Link>
                                <Link to="/regulamin" className="site-footer-policy-link">Regulamin serwisu</Link>
                                <Link to="/rodo" className="site-footer-policy-link">Klauzula informacyjna</Link>
                            </div>
                            <p className="site-footer-copyright">
                                Wszelkie prawa zastrzeżone &copy; {new Date().getFullYear()} GO-auto
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </Fragment>
    );
}

export default Footer;
